// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-k_hb","advertDetailHeaderPrice__value":"c-k_hc","advertDetailHeaderPrice__label":"c-k_he"};